import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../home/components/Footer';
import { useState } from 'react';

export default function CasesPage() {
  const [activeCategory, setActiveCategory] = useState('全部');

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://documogul.com';
    
    document.title = '客户成功案例 - 银行、医疗、教育行业PDF解决方案 | 星允信息';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '星允信息客户成功案例展示，包括银行数字化合同管理、医疗电子病历系统、教育在线文档平台等行业解决方案。见证800+企业如何通过我们的PDF技术实现数字化转型，提升业务效率。');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '客户案例,成功案例,银行PDF解决方案,医疗文档管理,教育云平台,数字化转型案例');
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${siteUrl}/cases`);

    // Add structured data for case studies
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "客户成功案例 - 星允信息",
      "description": "见证行业领先企业如何通过我们的PDF解决方案实现数字化转型，提升业务效率",
      "url": `${siteUrl}/cases`,
      "mainEntity": {
        "@type": "ItemList",
        "name": "客户成功案例",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "item": {
              "@type": "Article",
              "headline": "某大型银行数字化合同管理系统",
              "description": "通过部署Adobe PDF Library SDK，实现了全行业务合同的数字化管理",
              "author": {
                "@type": "Organization",
                "name": "星允信息科技有限公司"
              },
              "publisher": {
                "@type": "Organization",
                "name": "星允信息科技有限公司"
              },
              "datePublished": "2023-01-01"
            }
          },
          {
            "@type": "ListItem",
            "position": 2,
            "item": {
              "@type": "Article",
              "headline": "某医疗机构电子病历智能管理平台",
              "description": "基于PDF技术构建的电子病历系统，实现了病历的标准化生成、安全存储和智能检索",
              "author": {
                "@type": "Organization",
                "name": "星允信息科技有限公司"
              },
              "publisher": {
                "@type": "Organization",
                "name": "星允信息科技有限公司"
              },
              "datePublished": "2023-01-01"
            }
          }
        ]
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const categories = ['全部', '银行信贷', '医疗健康', '教育培训', '物流运输', '保险', '公共事业'];

  const cases = [
    {
      id: 1,
      category: '银行信贷',
      company: '某大型银行',
      title: '数字化合同管理系统',
      description: '通过部署Adobe PDF Library SDK，实现了全行业务合同的数字化管理，包括合同生成、电子签名、归档存储等全流程自动化。系统上线后，合同处理效率提升300%，年节省纸张成本超过500万元。',
      challenge: '传统纸质合同管理效率低下，存储成本高，查询困难',
      solution: 'PDF自动化生成、数字签名集成、智能归档系统',
      results: ['合同处理效率提升300%', '年节省成本500万+', '合同查询时间缩短至秒级', '实现全流程无纸化'],
      image: 'https://public.readdy.ai/ai/img_res/5b348d1a8f81e7dbf859afa0ba48edd2.jpg',
      logo: 'ri-bank-line',
      year: '2023'
    },
    {
      id: 2,
      category: '医疗健康',
      company: '某医疗机构',
      title: '电子病历智能管理平台',
      description: '基于PDF技术构建的电子病历系统，实现了病历的标准化生成、安全存储和智能检索。通过AI文档分析技术，可以快速提取病历关键信息，辅助医生诊断决策。',
      challenge: '海量病历管理困难，信息提取效率低，数据安全要求高',
      solution: 'PDF标准化模板、AI智能分析、多重加密保护',
      results: ['病历检索效率提升500%', '信息提取准确率98%', '符合医疗数据安全标准', '医生工作效率提升40%'],
      image: 'https://readdy.ai/api/search-image?query=Modern%20hospital%20medical%20records%20room%20with%20digital%20displays%20showing%20electronic%20health%20records%2C%20doctors%20reviewing%20patient%20data%20on%20tablets%20and%20computers%2C%20clean%20medical%20facility%20with%20teal%20and%20cyan%20color%20scheme%20lighting%2C%20advanced%20healthcare%20technology%20interface%20with%20patient%20information%20charts&width=800&height=500&seq=case-hospital-teal&orientation=landscape',
      logo: 'ri-hospital-line',
      year: '2023'
    },
    {
      id: 3,
      category: '教育培训',
      company: '某教培集团',
      title: '在线教育文档云平台',
      description: '打造了覆盖全国的在线教育文档管理平台，支持课件制作、作业批改、成绩单生成等功能。学生和教师可以随时随地访问和编辑教学文档，实现了真正的云端教学。',
      challenge: '多地分校文档管理分散，教学资源共享困难',
      solution: 'PDF云服务平台、在线协作编辑、智能版本管理',
      results: ['覆盖全国200+校区', '月活跃用户50万+', '教学资源利用率提升80%', '文档协作效率提升200%'],
      image: 'https://readdy.ai/api/search-image?query=Modern%20education%20technology%20classroom%20with%20students%20using%20tablets%20and%20digital%20learning%20materials%2C%20interactive%20whiteboard%20displaying%20educational%20content%2C%20bright%20and%20spacious%20learning%20environment%20with%20teal%20and%20cyan%20lighting%2C%20cloud-based%20document%20sharing%20visualization%20with%20connected%20devices&width=800&height=500&seq=case-education-teal&orientation=landscape',
      logo: 'ri-book-open-line',
      year: '2022'
    },
    {
      id: 4,
      category: '物流运输',
      company: '某物流集团',
      title: '数字化单据管理系统',
      description: '为大型物流集团构建了全面的数字化单据管理系统，涵盖运单、发票、收据等各类物流单据的生成、流转和归档。系统支持多种单据格式转换，实现了从纸质单据到电子化的全面升级，大幅提升了物流效率。',
      challenge: '传统纸质单据管理效率低，单据丢失率高，查询困难',
      solution: 'PDF单据标准化生成、电子签名、智能归档系统',
      results: ['单据处理效率提升400%', '单据丢失率降低99%', '查询响应时间缩短至秒级', '年节省纸张成本300万+'],
      image: 'https://readdy.ai/api/search-image?query=Modern%20logistics%20warehouse%20with%20digital%20document%20management%20system%2C%20automated%20package%20sorting%20with%20electronic%20shipping%20labels%20and%20invoices%2C%20large%20screens%20displaying%20real-time%20logistics%20data%20and%20digital%20receipts%2C%20teal%20and%20cyan%20lighting%20with%20modern%20industrial%20design&width=800&height=500&seq=case-logistics-teal&orientation=landscape',
      logo: 'ri-truck-line',
      year: '2023'
    },
    {
      id: 5,
      category: '政府机构',
      company: '某保险公司',
      title: '数字化表单管理平台',
      description: '为大型保险公司打造了智能化表单管理平台，实现了保险申请、理赔、核保等各类表单的数字化处理。系统支持表单智能识别、数据自动提取和风险评估，大幅提升了保险业务处理效率和客户满意度。',
      challenge: '保险表单种类繁多，人工处理效率低，错误率高',
      solution: 'PDF表单智能识别、数据自动提取、风险评估系统',
      results: ['表单处理效率提升350%', '数据准确率提升至99.5%', '客户满意度提升至96%', '理赔处理时间缩短70%'],
      image: 'https://readdy.ai/api/search-image?query=Modern%20insurance%20company%20office%20with%20digital%20form%20processing%20system%2C%20insurance%20agents%20reviewing%20electronic%20claims%20and%20applications%20on%20computers%2C%20professional%20financial%20services%20environment%20with%20teal%20and%20cyan%20corporate%20lighting%2C%20automated%20document%20workflow%20visualization&width=800&height=500&seq=case-insurance-teal&orientation=landscape',
      logo: 'ri-shield-check-line',
      year: '2022'
    },
    {
      id: 6,
      category: '公共事业',
      company: '某图书馆',
      title: '数字化图书馆管理系统',
      description: '为现代化图书馆建设了全面的数字化管理系统，实现了图书借阅、归还、续借等业务的无纸化操作。系统支持电子借阅证、数字化图书目录和智能推荐功能，为读者提供了更便捷的阅读体验。',
      challenge: '传统图书管理效率低，读者体验差，资源利用率不高',
      solution: 'PDF电子借阅系统、数字化目录、智能推荐算法',
      results: ['借阅效率提升200%', '读者满意度提升至94%', '图书利用率提升60%', '管理成本降低40%'],
      image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20library%20with%20electronic%20book%20management%20system%2C%20readers%20using%20tablets%20and%20self-service%20kiosks%20for%20book%20borrowing%2C%20digital%20catalog%20displays%20and%20automated%20book%20sorting%20system%2C%20warm%20lighting%20with%20teal%20and%20cyan%20accents%20and%20modern%20technology%20integration&width=800&height=500&seq=case-library-teal&orientation=landscape',
      logo: 'ri-book-open-line',
      year: '2023'
    }
  ];

  const filteredCases = activeCategory === '全部' 
    ? cases 
    : cases.filter(c => c.category === activeCategory);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-600 via-cyan-600 to-emerald-600 text-white py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6">
              客户成功案例
            </h1>
            <p className="text-xl lg:text-2xl text-teal-100 max-w-3xl mx-auto mb-8">
              见证行业领先企业如何通过我们的PDF解决方案实现数字化转型，提升业务效率
            </p>
            <div className="flex flex-wrap justify-center gap-6 text-center">
              <div>
                <div className="text-4xl font-bold mb-2">800+</div>
                <div className="text-teal-200">成功案例</div>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">98%</div>
                <div className="text-teal-200">客户满意度</div>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">8年</div>
                <div className="text-teal-200">行业经验</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-gray-50 sticky top-0 z-10 shadow-sm">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-6 py-2 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  activeCategory === category
                    ? 'bg-teal-600 text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Cases Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="space-y-16">
            {filteredCases.map((caseItem, index) => (
              <div 
                key={caseItem.id} 
                className={`flex flex-col lg:flex-row items-center gap-12 ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
              >
                <div className="flex-1">
                  <img 
                    src={caseItem.image}
                    alt={caseItem.title}
                    className="w-full h-96 object-cover object-top rounded-xl shadow-2xl"
                  />
                </div>
                
                <div className="flex-1">
                  <div className="flex items-center mb-4">
                    <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mr-4">
                      <i className={`${caseItem.logo} text-3xl text-teal-600`}></i>
                    </div>
                    <div>
                      <span className="inline-block bg-teal-100 text-teal-600 px-3 py-1 rounded-full text-sm font-semibold mb-2">
                        {caseItem.category}
                      </span>
                      <h3 className="text-3xl font-bold text-gray-900">{caseItem.company}</h3>
                    </div>
                  </div>

                  <h4 className="text-2xl font-bold text-gray-900 mb-4">{caseItem.title}</h4>
                  
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {caseItem.description}
                  </p>

                  <div className="bg-gray-50 rounded-lg p-6 mb-6">
                    <div className="mb-4">
                      <h5 className="font-bold text-gray-900 mb-2 flex items-center">
                        <i className="ri-error-warning-line text-red-500 mr-2"></i>
                        面临挑战
                      </h5>
                      <p className="text-gray-600">{caseItem.challenge}</p>
                    </div>
                    <div>
                      <h5 className="font-bold text-gray-900 mb-2 flex items-center">
                        <i className="ri-lightbulb-line text-yellow-500 mr-2"></i>
                        解决方案
                      </h5>
                      <p className="text-gray-600">{caseItem.solution}</p>
                    </div>
                  </div>

                  <div className="mb-6">
                    <h5 className="font-bold text-gray-900 mb-3 flex items-center">
                      <i className="ri-trophy-line text-green-500 mr-2"></i>
                      实施成果
                    </h5>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      {caseItem.results.map((result) => (
                        <div key={result} className="flex items-center">
                          <i className="ri-check-line text-green-500 text-xl mr-2"></i>
                          <span className="text-gray-700">{result}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                    <span className="text-sm text-gray-500">实施年份：{caseItem.year}</span>
                    <a href={caseItem.id === 1 ? "/case-bank-detail" : caseItem.id === 2 ? "/case-medical-detail" : caseItem.id === 3 ? "/case-education-detail" : "#"} className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
                      查看详情
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              用数据说话
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              我们的解决方案为客户带来的实际价值
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { number: '800+', label: '服务企业', icon: 'ri-building-line' },
              { number: '1000万+', label: '日处理文档', icon: 'ri-file-line' },
              { number: '99.9%', label: '系统稳定性', icon: 'ri-shield-check-line' },
              { number: '8x7', label: '技术支持', icon: 'ri-customer-service-2-line' }
            ].map((stat) => (
              <div key={stat.label} className="bg-white rounded-xl p-8 text-center shadow-lg">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${stat.icon} text-3xl text-teal-600`}></i>
                </div>
                <div className="text-4xl font-bold text-teal-600 mb-2">{stat.number}</div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-teal-600 to-cyan-600 text-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            成为我们的下一个成功案例
          </h2>
          <p className="text-xl text-teal-100 mb-8">
            让我们的专业团队为您量身定制PDF解决方案，助力您的企业数字化转型
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a href="/contact" className="bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer">
              立即咨询
            </a>
            <a href="/services" className="bg-teal-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-400 transition-colors whitespace-nowrap cursor-pointer border-2 border-white">
              查看服务
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
